import React, { Component } from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import PropTypes from "prop-types";
import isEmpty from "lodash/isEmpty";
import { get, includes, size, keys, forEach } from "lodash";
//import Mousetrap from "mousetrap";

import { fetchGet } from "../../../api/fetch";

import {
  updateOneLog,
  setDetection,
  setMainNotes,
  fetchTabData,
} from "../../../actions/siteEntranceExit/tabs";

import Grid from "@material-ui/core/Grid";

import Loader from "../../Common/Loader";
import LogDetailsSummary from "./LogDetailsSummary";
import LogDetailsDriverNew from "./LogDetailsDriverNew";
import LogDetailsVehicle from "./LogDetailsVehicle";
import LogDetailsVerification from "./LogDetailsVerification";
import LogDetailsTemperature from "./LogDetailsTemperature";
import LogDetailsNotes from "./LogDetailsNotes";
import LogDetailsTabs from "./LogDetailsTabs";
//import AddDetection from "./AddDetection";

import {
  getOcrGroupedByPhotos,
  getLprDetails,
  getFrDetails,
} from "../../../utils/detectionDetails";
import { getLov } from "../../../utils/lov";
import { copyTextToClipboard } from "../../../utils/copyToClipboard";
import { formatDate } from "../../../utils/date";
import { getOverrideEvent } from "../../../utils/eventGroups";
import {
  human,
  driver,
  passenger,
  truck,
  trailer,
  trailer1,
  trailer2,
  FACE_DETECT,
  HUMAN_DETECT,
  HUMAN_EXIT,
  logDetailsTabs,
  container1,
  container,
  container2,
} from "../../../constants/common";
import { driveInOut, walkInOut } from "../../../constants/reducers";

import colors from "../../../assets/style/colors";
import ChangeDecisionDialog from "../../Common/ChangeDecisionDialog";

const styles = {
  container: {
    boxShadow: "0px 0px 4px 0px " + colors.black23,
    borderRadius: "4px",
    backgroundColor: colors.white,
    margin: "0px",
    minHeight: "250px",
    height: "calc(100% - 36px)",
  },
  root: {
    zIndex: "950 !important",
  },
  dialog: {
    width: "calc(100vw - 100px)",
    maxWidth: "1200px",
    height: "calc(100vh - 100px)",
    maxHeight: "1000px",
    borderRadius: "2px",
  },
  titleBar: {
    zIndex: 1,
    height: "40px",
    margin: "25px 0px 0px 0px",
    borderBottom: "1px solid " + colors.pinkishGrey,
    display: "flex",
  },
  closeIcon: {
    margin: "18px",
    cursor: "pointer",
    opacity: "0.54",
    transform: "scale(0.85)",
  },
  contentContainer: {
    backgroundColor: colors.cardDarkBg,
    padding: "24px",
    paddingBottom: "2px",
    overflow: "auto",
  },
  infoContainer: {
    border: "1px solid " + colors.veryLighPink,
    borderRadius: "2px",
    margin: "10px 10px 30px 10px",
    padding: "0px 15px 15px 15px",
  },
  infoTitle: {
    color: colors.black54,
    background: colors.white,
    transform: "translate(12px, -12px) scale(1.0)",
    display: "inline-block",
    padding: "0px 3px",
  },
  dataBlock: {
    marginBottom: "15px",
  },
  actionBar: {
    backgroundColor: colors.cardDarkBg,
    height: "60px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& button": {
      margin: "-1px 15px 0px 15px",
    },
  },
  radioBtn: {
    padding: 0,
    margin: "0px 4px 0px 7px",
    transform: "scale(0.8)",
  },
  radioLabel: {
    marginRight: "20px",
  },
  verifiedIcon: {
    margin: "0px 3px",
  },
  infoItem: {
    paddingLeft: "15px",
    paddingRight: "15px",
  },
  pictureContainer: {
    height: "40px",
    display: "flex",
    alignItems: "center",
  },
  link: {
    color: colors.primary,
  },
  clickableBoxTitle: {
    color: colors.primary,
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
    },
  },
};

class LogDetails extends Component {
  mounted = false;
  initialized = false;

  constructor(props) {
    super(props);
    this.state = {
      tabValue:
        props.activeLogDetailsTab === "main"
          ? logDetailsTabs.summary
          : props.activeLogDetailsTab === driver
          ? driver
          : props.activeLogDetailsTab === passenger
          ? passenger
          : props.activeLogDetailsTab === human
          ? human
          : props.activeLogDetailsTab === truck
          ? truck
          : props.activeLogDetailsTab === "verification"
          ? logDetailsTabs.verification
          : props.activeLogDetailsTab === trailer1
          ? trailer1
          : props.activeLogDetailsTab === trailer2
          ? trailer2
          : props.activeLogDetailsTab === "temperature"
          ? logDetailsTabs.temperature
          : logDetailsTabs.summary,
      lov: {},
      profileCreated: {},
      notes: [],
      detection: get(props, ["log", "detection"]) || {},
      mainNotes: get(props, ["log", "mainNotes"]) || [],
      isLoadingLogs: false,
    };
  }

  componentDidMount() {
    this.mounted = true;
    // Mousetrap.bind("ctrl+c", () => {
    //   this.copyToClipboard();
    //   return false;
    // });
    this.initialize();
    // console.log("LogDetail triggering data load on mounting");
    this.setState({ isLoadingLogs: true });
    this.props.dispatch(fetchTabData(this.props.section, this.props.tab));
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  componentDidUpdate(prevProps, prevState) {
    // console.log('LogDetails cDU - ', this.props.log?.id, this.state.logId);
    let shouldSearchOverrides = false;
    if (get(prevProps, ["log", "detections"])) {
      let keys = Object.keys(prevProps.log.detections);
      keys.forEach((k) => {
        if (
          size(get(prevProps, ["log", "detections", k, "events"])) !==
          size(get(this.props, ["log", "detections", k, "events"]))
        ) {
          shouldSearchOverrides = true;
        }
      });
    }
    if (!this.state.overrides || shouldSearchOverrides) {
      this.searchOverrides();
    }
    if (!this.state.isLoadingLogs && !this.props.log?.id) {
      console.log("LogDetail triggering data load on update with no log");
      this.setState({ isLoadingLogs: true });
      this.props.dispatch(fetchTabData(this.props.section, this.props.tab));
      this.fetchChildrenEventGroups();
    } else {
      if (this.props.log?.id && this.state.isLoadingLogs) {
        console.log("LogDetails logs are loaded.")
        this.setState({ isLoadingLogs: false });
      }
    }
    if (
      this.props.log &&
      this.state.logId &&
      this.props.log.id !== this.state.logId &&
      !this.state.isLoadingLogs
    ) {
      // Force refresh on focus
      console.log("LogDetail triggering data load on update with log already loaded");
      this.setState({ isLoadingLogs: true });
      this.props.dispatch(fetchTabData(this.props.section, this.props.tab));
      this.fetchChildrenEventGroups();

      this.setState({
        overrides: null,
        logId: this.props.log.id,
        detection: this.props.log.detection || {},
        mainNotes: this.props.log.mainNotes,
        notes: [],
      });
    }

    // Refresh on activeLogDetailsTab change
    if (
      get(prevState, ["tabValue"]) !== get(this.state, ["tabValue"]) ||
      JSON.stringify(get(prevProps, ["log"])) !==
        JSON.stringify(get(this.props, ["log"]))
    ) {
      this.fetchChildrenEventGroups();
    }

    if (
      !this.state.loadingNotes &&
      (isEmpty(this.state.detection) || !this.state.mainNotes)
    ) {
      this.initialize();
    }

    forEach([passenger, trailer2, container1, container2], (type) => {
      if (
        this.state.tabValue === type &&
        isEmpty(get(this.props, ["log", "detections", type]))
      ) {
        this.setState({
          tabValue: logDetailsTabs.summary,
        });
      }
    });
  }

  initialize = async () => {
    if (this.props.log && this.props.log.id) {
      this.initialized = true;
      this.setState({ loadingNotes: true, logId: this.props.log.id });

      try {
        // Fetch lov
        let lov = {
          107: await getLov(107),
          110: await getLov(110),
          35: await getLov(35),
          36: await getLov(36),
          42: await getLov(42),
          53: await getLov(53),
          89: await getLov(89),
          135: await getLov(135),
          tags: await getLov("tags"),
        };

        if (this.mounted) {
          this.setState({ lov });
        }
      } catch (e) {
        console.log(e);
      }
      await this.fetchChildrenEventGroups();
    }
  };

  searchOverrides = async () => {
    if (get(this.props, ["log", "detections"])) {
      this.setState({ overrides: "isFetching" });
      let overrides = {};
      let keys = Object.keys(this.props.log.detections);
      for (let i = 0; i < keys.length; i++) {
        overrides[keys[i]] = await getOverrideEvent(
          this.props.log.detections[keys[i]]
        );
      }
      this.setState({ overrides });
    }
  };

  copyToClipboard = () => {
    let text = "";
    text += `${get(this.props, ["log", "complete", "id"])},`;
    text += `"${get(this.props, ["log", "main", "zone"])}",`;
    text += `"${formatDate(
      new Date(get(this.props, ["log", "main", "modifiedOn"])),
      "MM/DD/YYYY"
    )}",`;
    text += `"${formatDate(
      new Date(get(this.props, ["log", "main", "modifiedOn"])),
      "hh:mm:ss A"
    )}",`;

    if (this.props.section === driveInOut) {
      text += get(this.props, ["log", driver, "name"])
        ? `"${get(this.props, ["log", driver, "name"])}",`
        : ",";
      text += get(this.props, ["log", truck, "name"])
        ? `"${get(this.props, ["log", truck, "name"])}",`
        : ",";
      text += get(this.props, ["log", trailer1, "name"])
        ? `"${get(this.props, ["log", trailer1, "name"])}",`
        : ",";

      text += get(this.props, ["log", driver, "id"])
        ? `"${get(this.props, ["log", driver, "id"])}",`
        : ",";
      text += get(this.props, ["log", truck, "id"])
        ? `"${get(this.props, ["log", truck, "id"])}",`
        : ",";
      text += get(this.props, ["log", trailer1, "id"])
        ? `"${get(this.props, ["log", trailer1, "id"])}"`
        : "";
    } else if (this.props.section === walkInOut) {
      text += get(this.props, ["log", human, "name"])
        ? `"${get(this.props, ["log", human, "name"])}",`
        : ",";
      text += get(this.props, ["log", human, "id"])
        ? `"${get(this.props, ["log", human, "id"])}",`
        : ",";
    }

    copyTextToClipboard(text);
  };

  refreshDetectionEventGroup = async (type) => {
    try {
      this.props.dispatch(
        updateOneLog(
          this.props.section,
          this.props.tabIndex,
          null,
          this.props.log.id
        )
      );
    } catch (e) {
      console.log(e);
    }
  };

  handleTabChange = (event, newValue) => {
    this.setState({ tabValue: newValue });
  };

  fetchChildrenEventGroups = async () => {
    if (!this.props.log?.id) {
      console.log("LogDetails - skipping child event groups");
      return null;
    }
    try {
      console.log("LogDetails - loading child event groups");
      if (!this.state.isFetching) {
        this.setState({ isFetching: true });
        let tabIndex = this.props.tabIndex;

        let detection = {};
        forEach(
          [
            human,
            driver,
            passenger,
            truck,
            trailer1,
            trailer2,
            container1,
            container2,
          ],
          (type) => {
            detection[type] = get(this.props.log, ["detections", type]);
            if (!isEmpty(get(detection, [type]))) {
              detection[type].contextPhotos = [];
              forEach(get(detection, [type, "events"]), (e) => {
                if (e.active && e.images) {
                  detection[type].contextPhotos.push(
                    ...e.images.map((i) => ({
                      url: i.url,
                      type:
                        get(e, ["type", "id"]) === 1
                          ? HUMAN_DETECT
                          : get(e, ["type", "id"]) === 2
                          ? FACE_DETECT
                          : get(e, ["type", "id"]) === 3
                          ? HUMAN_EXIT
                          : "",
                    }))
                  );
                }
              });
            }
          }
        );

        if (this.props.section === driveInOut) {
          if (!isEmpty(get(detection, [driver]))) {
            detection.driver.fr = getFrDetails(detection.driver);
          }
          if (!isEmpty(get(detection, [passenger]))) {
            detection.passenger.fr = getFrDetails(detection.passenger);
          }
          forEach(
            [truck, trailer1, trailer2, container1, container2],
            (type) => {
              if (!isEmpty(get(detection, [type]))) {
                detection[type].ocr = getOcrGroupedByPhotos(detection[type]);
                detection[type].lpr = getLprDetails(detection[type]);
              }
            }
          );
        } else if (this.props.section === walkInOut) {
          detection.human.fr = getFrDetails(detection.human);
        }

        // Fetch notes
        let mainNotes = await fetchGet(
          "event_groups/" + this.props.log.id + "/notes"
        );

        if (this.mounted) {
          this.props.dispatch(
            setDetection(this.props.section, tabIndex, detection)
          );
          this.props.dispatch(
            setMainNotes(this.props.section, tabIndex, mainNotes)
          );
          this.setState({
            detection,
            mainNotes,
            loadingNotes: false,
            isFetching: false,
          });
        }
      }
    } catch (e) {
      console.log(e);
    }
  };

  handleProfileCreated = (type, profile, note = null) => {
    this.props.dispatch(
      updateOneLog(
        this.props.section,
        this.props.tabIndex,
        this.props.openFromTab,
        this.props.log.id
      )
    );
  };

  addNote = async (note) => {
    console.log("new note", note);
    await this.setState({
      notes: [...this.state.notes, note],
    });
  };

  getProfileProps = (type) => {
    let log = get(this.props, ["log", "detections", type]);
    let details = {
      dacId: this.props.log.id,
      dacEventGroup: get(this.props, ["log", "complete"]),
      detectionId: get(this.state.detection, [type, "id"]) || "",
      detectionEventGroup: get(this.props, ["log", "detections", type]) || null,
      log,
      lov: this.state.lov,
      handleProfileOverride: this.handleProfileCreated,
      contextPhotos: get(this.state.detection, [type, "contextPhotos"]) || [],
      ocr: get(this.state.detection, [type, "ocr"]) || [],
      lpr: get(this.state.detection, [type, "lpr"]) || [],
      fr: get(this.state.detection, [type, "fr"]) || [],
      lukeIndex: get(this.props, ["log", "detections", type, "luke_index"]),
      override: get(this.state, ["overrides", type]),
    };
    if (
      includes([trailer1, trailer2], type) &&
      (!get(this.props, ["log", "detections", type]) ||
        isEmpty(get(this.props, ["log", "detections", type])))
    ) {
      details.truckImages = {
        contextPhotos:
          get(this.state.detection, [truck, "contextPhotos"]) || [],
        ocr: get(this.state.detection, [truck, "ocr"]) || [],
        lpr: get(this.state.detection, [truck, "lpr"]) || [],
      };
      details.truckDetectionEventGroup = get(this.props, [
        "log",
        "detections",
        truck,
      ]);
    }
    return details;
  };

  getNotesCount = () => {
    let count = 0;
    let notes = this.getNotes();
    Object.keys(notes).forEach((k) => {
      count += notes[k].length;
    });
    return count;
  };

  getNotes = () => {
    let notes = {
      main: this.state.mainNotes || [],
    };
    [
      human,
      driver,
      truck,
      trailer,
      trailer1,
      trailer2,
      container1,
      container2,
    ].forEach((type) => {
      notes[type] = [];
      if (
        this.state.detection &&
        this.state.detection[type] &&
        this.state.detection[type] &&
        this.state.detection[type].notes
      ) {
        notes[type] = [...notes[type], ...this.state.detection[type].notes];
      }
      if (this.props.log[type] && this.props.log[type].notes) {
        notes[type] = [...notes[type], ...this.props.log[type].notes];
      }
    });
    if (this.state.notes && this.state.notes.length > 0) {
      this.state.notes.forEach((note) => {
        if (note && note.related) {
          notes[note.related] = [...notes[note.related], note];
        }
      });
    }
    return notes;
  };

  getEventGroupIds = () => {
    let ids = {
      main: this.props.log.complete.id,
      human: null,
      driver: null,
      truck: null,
      trailer: null,
    };
    [
      human,
      driver,
      passenger,
      truck,
      trailer,
      trailer1,
      trailer2,
      container1,
      container2,
    ].forEach((type) => {
      if (this.state.detection[type]) {
        ids[type] = this.state.detection[type].id;
      }
    });
    return ids;
  };

  onRemovingTab=()=>{
    this.setState({
      tabValue: logDetailsTabs.summary,
    })
    this.handleProfileCreated()
  }

  render() {
    const { classes, log, section } = this.props;

    return size(keys(log)) > 0 ? (
      <Grid
        container
        direction="column"
        wrap="nowrap"
        className={classes.container}
      >
        <Grid item className={classes.titleBar}>
          <LogDetailsTabs
            section={section}
            log={log}
            tabValue={this.state.tabValue}
            handleTabChange={this.handleTabChange}
            overrides={this.state.overrides}
            getNotesCount={this.getNotesCount}
            tab={this.props.tab}
            fetchChildrenEventGroups={this.fetchChildrenEventGroups}
          />
          {/* <ChangeDecisionDialog
            log={get(log, ["complete"])}
            refreshLog={this.refreshDetectionEventGroup}
            style={{ paddingRight: "10px" }}
            section={section}
          /> */}
        </Grid>
        <Grid
          item
          xs
          style={{ padding: "14px", paddingTop: "35px", overflow: "auto" }}
        >
          {section === driveInOut ? (
            this.state.tabValue === driver ? (
              <LogDetailsDriverNew
                section={this.props.section}
                classes={classes}
                language={this.props.language}
                details={this.getProfileProps(driver)}
                updateHistory={this.props.updateHistory}
                powerUserMode={this.props.common.powerUserModeEnabled}
                addNote={this.addNote}
                onRemovingTab={this.onRemovingTab}
                tabs={{
                  openFrom: this.props.openFromTab,
                  tabIndex: this.props.tabIndex,
                }}
                log={this.props.log}
              />
            ) : this.state.tabValue === passenger ? (
              <LogDetailsDriverNew
                section={this.props.section}
                classes={classes}
                language={this.props.language}
                details={this.getProfileProps(passenger)}
                updateHistory={this.props.updateHistory}
                powerUserMode={this.props.common.powerUserModeEnabled}
                addNote={this.addNote}
                onRemovingTab={this.onRemovingTab}
                tabs={{
                  openFrom: this.props.openFromTab,
                  tabIndex: this.props.tabIndex,
                }}
                log={this.props.log}
              />
            ) : this.state.tabValue === truck ? (
              <LogDetailsVehicle
                section={this.props.section}
                type={truck}
                language={this.props.language}
                details={this.getProfileProps(truck)}
                powerUserMode={this.props.common.powerUserModeEnabled}
                addNote={this.addNote}
                refreshDetectionEventGroup={this.refreshDetectionEventGroup}
                onRemovingTab={this.onRemovingTab}
                tabs={{
                  openFrom: this.props.openFromTab,
                  tabIndex: this.props.tabIndex,
                }}
                log={this.props.log}
              />
            ) : this.state.tabValue === trailer1 ? (
              <LogDetailsVehicle
                section={this.props.section}
                type={trailer}
                language={this.props.language}
                details={this.getProfileProps(trailer1)}
                powerUserMode={this.props.common.powerUserModeEnabled}
                addNote={this.addNote}
                refreshDetectionEventGroup={this.refreshDetectionEventGroup}
                onRemovingTab={this.onRemovingTab}
                tabs={{
                  openFrom: this.props.openFromTab,
                  tabIndex: this.props.tabIndex,
                }}
                log={this.props.log}
              />
            ) : this.state.tabValue === trailer2 ? (
              <LogDetailsVehicle
                section={this.props.section}
                type={trailer}
                language={this.props.language}
                details={this.getProfileProps(trailer2)}
                powerUserMode={this.props.common.powerUserModeEnabled}
                addNote={this.addNote}
                refreshDetectionEventGroup={this.refreshDetectionEventGroup}
                onRemovingTab={this.onRemovingTab}
                tabs={{
                  openFrom: this.props.openFromTab,
                  tabIndex: this.props.tabIndex,
                }}
                log={this.props.log}
              />
            ) : this.state.tabValue === container1 ? (
              <LogDetailsVehicle
                section={this.props.section}
                type={container}
                language={this.props.language}
                details={this.getProfileProps(container1)}
                powerUserMode={this.props.common.powerUserModeEnabled}
                addNote={this.addNote}
                refreshDetectionEventGroup={this.refreshDetectionEventGroup}
                onRemovingTab={this.onRemovingTab}
                tabs={{
                  openFrom: this.props.openFromTab,
                  tabIndex: this.props.tabIndex,
                }}
                log={this.props.log}
              />
            ) : this.state.tabValue === container2 ? (
              <LogDetailsVehicle
                section={this.props.section}
                type={container}
                language={this.props.language}
                details={this.getProfileProps(container2)}
                powerUserMode={this.props.common.powerUserModeEnabled}
                addNote={this.addNote}
                refreshDetectionEventGroup={this.refreshDetectionEventGroup}
                onRemovingTab={this.onRemovingTab}
                tabs={{
                  openFrom: this.props.openFromTab,
                  tabIndex: this.props.tabIndex,
                }}
                log={this.props.log}
              />
            ) : this.state.tabValue === logDetailsTabs.notes ? (
              <LogDetailsNotes
                notes={this.getNotes()}
                user={this.props.user}
                addNote={this.addNote}
                loading={this.state.loadingNotes}
                eventGroupIds={this.getEventGroupIds()}
                log={this.props.log}
              />
            ) : (
              <LogDetailsSummary
                section={this.props.section}
                log={log}
                language={this.props.language}
                tabs={{
                  openFrom: this.props.openFromTab,
                  tabIndex: this.props.tabIndex,
                }}
              />
            )
          ) : section === walkInOut ? (
            this.state.tabValue === human ? (
              <LogDetailsDriverNew
                section={this.props.section}
                classes={classes}
                language={this.props.language}
                details={this.getProfileProps(human)}
                updateHistory={this.props.updateHistory}
                powerUserMode={this.props.common.powerUserModeEnabled}
                addNote={this.addNote}
                onRemovingTab={this.onRemovingTab}
                tabs={{
                  openFrom: this.props.openFromTab,
                  tabIndex: this.props.tabIndex,
                }}
                log={this.props.log}
              />
            ) : this.state.tabValue === logDetailsTabs.verification ? (
              <LogDetailsVerification
                section={this.props.section}
                log={this.props.log}
                language={this.props.language}
                tabs={{
                  openFrom: this.props.openFromTab,
                  tabIndex: this.props.tabIndex,
                }}
                powerUserMode={this.props.common.powerUserModeEnabled}
              />
            ) : this.state.tabValue === logDetailsTabs.temperature ? (
              <LogDetailsTemperature
                details={this.getProfileProps(human)}
                log={log}
                language={this.props.language}
                refreshDetection={this.refreshDetectionEventGroup}
              />
            ) : this.state.tabValue === logDetailsTabs.notes ? (
              <LogDetailsNotes
                notes={this.getNotes()}
                user={this.props.user}
                addNote={this.addNote}
                loading={this.state.loadingNotes}
                eventGroupIds={this.getEventGroupIds()}
                log={this.props.log}
              />
            ) : (
              <LogDetailsSummary
                section={this.props.section}
                log={log}
                language={this.props.language}
                tabs={{
                  openFrom: this.props.openFromTab,
                  tabIndex: this.props.tabIndex,
                }}
              />
            )
          ) : (
            <></>
          )}
        </Grid>
      </Grid>
    ) : (
      <Grid
        container
        direction="column"
        wrap="nowrap"
        className={classes.container}
        alignItems="center"
        justify="center"
      >
        <Grid item>
          <Loader noDecoration />
        </Grid>
      </Grid>
    );
  }
}

LogDetails.propTypes = {
  // open: PropTypes.bool.isRequired,
  // close: PropTypes.func.isRequired,
  log: PropTypes.object,
  tab: PropTypes.object,
  section: PropTypes.oneOf([driveInOut, walkInOut]),
};

const mapStateToProps = (state) => {
  return {
    siteEntranceExit: state.siteEntranceExit,
    language: state.user.language,
    user: state.user,
    common: state.common,
  };
};

export default connect(mapStateToProps)(withStyles(styles)(LogDetails));
